import { Col, Divider, Row } from "antd";
import { Content } from "antd/lib/layout/layout";
import MetricsToolbar, { DefaultOptions, MetricsType, Timeframe, ToolbarOptions } from "components/staff/Metrics/MetricsToolbar";
import { PullerTable, ShipperTable } from "components/staff/Metrics/MetricTables";
import { useCallback, useState } from "react";
import { MetricsRequest } from "./useMetrics";

const ShipmentMetrics = () => {
    const [options, setOptions] = useState<ToolbarOptions>(DefaultOptions);

    const toMetricsRequest = useCallback((): MetricsRequest => {
        let withinLast: string | undefined;

        switch (options.timeframe) {
            case Timeframe.Last24Hours:
                withinLast = "1.00:00:00";
                break;
            case Timeframe.Last7Days:
                withinLast = "7.00:00:00";
                break;
            case Timeframe.Last30Days:
                withinLast = "30.00:00:00";
                break;
            case Timeframe.Last120Days:
                withinLast = "120.00:00:00";
                break;
            default:
                withinLast = undefined;
                break;
        }

        return {
            start: options.timeframe === Timeframe.Custom
                ? options.customStart!.toISOString()
                : undefined,
            end: options.timeframe === Timeframe.Custom
                ? options.customEnd!.toISOString()
                : undefined,
            withinLast,
            userId: options.userId
        }
    }, [options]);

    return <Content style={{ padding: '50px' }}>
        <Row gutter={[32, 32]}>
            <Col span={24} style={{ fontSize: '36px' }}>Shipment Metrics</Col>
        </Row>
        <Divider />

        <MetricsToolbar
            onChange={setOptions}
        />

        {options.type === MetricsType.Puller && <PullerTable
            {...toMetricsRequest()}
        />}

        {options.type === MetricsType.Shipper && <ShipperTable
            {...toMetricsRequest()}
        />}
    </Content>;
}

export default ShipmentMetrics;